import { render, staticRenderFns } from "./sellAdd.vue?vue&type=template&id=4d098f7a&scoped=true"
import script from "./sellAdd.vue?vue&type=script&lang=js"
export * from "./sellAdd.vue?vue&type=script&lang=js"
import style0 from "./sellAdd.vue?vue&type=style&index=0&id=4d098f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d098f7a",
  null
  
)

export default component.exports